import React, { useRef } from "react";
import styles from "./date-input-field.module.scss";
import { CalendarIcon } from "../../../../../assets/icons";

interface DateInputFieldProps {
	value?: string;
	onChange: (value: string | null) => void;
	placeholder?: string;
	hasError?: boolean;
	disabled?: boolean;
}

const DateInputField: React.FC<DateInputFieldProps> = ({
	value,
	onChange,
	placeholder = "Select date",
	hasError = false,
	disabled = false,
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	const formatDisplay = (iso: string): string => {
		const date = new Date(iso);
		if (isNaN(date.getTime())) return iso;
		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		return `${day}/${month}/${date.getFullYear()}`;
	};

	const openPicker = () => {
		if (disabled) return;
		const input = inputRef.current;
		if (!input) return;
		// showPicker is supported in modern browsers; fall back to focus/click.
		if (typeof (input as any).showPicker === "function") {
			(input as any).showPicker();
		} else {
			input.click();
		}
	};

	return (
		<button
			type="button"
			className={`${styles.trigger} ${hasError ? styles.error : ""}`}
			onClick={openPicker}
			disabled={disabled}
		>
			<span className={value ? styles.value : styles.placeholder}>{value ? formatDisplay(value) : placeholder}</span>
			<CalendarIcon className={styles.icon} />
			<input
				ref={inputRef}
				type="date"
				className={styles.nativeInput}
				value={value ?? ""}
				disabled={disabled}
				onChange={e => onChange(e.target.value || null)}
			/>
		</button>
	);
};

export default DateInputField;
